import React from 'react';

export const Button = ({
    children,
    variant = 'primary',
    size = 'md',
    icon: Icon,
    iconPosition = 'left',
    isLoading = false,
    loadingText,
    fullWidth = false,
    className = '',
    disabled,
    ...props
}) => {
    const baseClass = 'btn-modern';
    const variantClass = `btn-modern-${variant}`;
    const sizeClass = size !== 'md' ? `btn-modern-${size}` : '';
    const widthClass = fullWidth ? 'btn-modern-full' : '';

    const combinedClassName = `${baseClass} ${variantClass} ${sizeClass} ${widthClass} ${className}`.trim();

    return (
        <button
            className={combinedClassName}
            disabled={disabled || isLoading}
            {...props}
        >
            {isLoading && (
                <svg className="animate-spin -ml-1 mr-2 h-4 w-4 text-current" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                    <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                    <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                </svg>
            )}
            {!isLoading && Icon && iconPosition === 'left' && <Icon size={size === 'sm' ? 14 : 18} />}
            {isLoading && loadingText ? loadingText : children}
            {!isLoading && Icon && iconPosition === 'right' && <Icon size={size === 'sm' ? 14 : 18} />}
        </button>
    );
};
